import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { MethodActions } from './method.actions';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { ScopeService } from '../../scope.service';
import { ScopeActions } from '../scope/scope.actions';

@Injectable()
export class MethodEffects {
  private readonly actions$ = inject(Actions);
  private readonly scopeService = inject(ScopeService);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);

  public getMethodsForScope$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ScopeActions.getPersonScopesSuccess),
      exhaustMap((action) =>
        this.scopeService
          .getMethodsForScope(action.scopes.map((scope) => scope.id))
          .pipe(
            map((methodsForScopeDto) =>
              MethodActions.getMethodsForScopeSuccess({ methodsForScopeDto }),
            ),
            catchError((error: Error) =>
              of(MethodActions.getMethodsForScopeFailure({ error })),
            ),
          ),
      ),
    );
  });

  public getPersonScopesFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(MethodActions.getMethodsForScopeFailure),
        map(() => {
          this.applicationFacade.showToaster({
            type: 'error',
            message: 'Het laden van de methodes is niet gelukt.',
          });
        }),
      );
    },
    { dispatch: false },
  );
}
